<template>
    <div
        class="relative z-20 flex flex-wrap items-center w-full pt-8 gap-y-4 md:pt-0 gap-x-6 sm:w-auto"
    >
        <span
            class="flex items-center mr-6 text-xl cursor-pointer text-primary sm:text-lg gap-x-2 sm:gap-x-0 sm:cursor-default"
            @click="toggleFilterHide()"
        >
            Filter
            <span class="hidden sm:inline-block">:</span>
            <Icon :name="filterIcon" class="inline-block w-6 h-6 sm:hidden" />
        </span>
        <div
            class="absolute left-0 z-20 flex flex-wrap items-center w-full px-4 overflow-hidden transition-all shadow-lg rounded-xl sm:rounded-none sm:relative sm:w-auto top-20 sm:top-0 gap-x-2 gap-y-2 bg-hover2 sm:bg-transparent sm:px-0 sm:shadow-none"
            :class="{
                'h-0 py-0': filterHidden,
                'h-[160px] py-4 sm:h-auto sm:py-0': !filterHidden,
            }"
        >
            <div
                v-for="(prop, index) in filterProps"
                :key="prop"
                :class="{
                    'bg-primaryColor text-text': activeFilters.includes(prop),
                    'bg-light text-primary': !activeFilters.includes(prop),
                }"
                class="flex px-4 py-2 text-sm rounded-md cursor-pointer gap-x-2"
                @click="toggleFilter(prop, index)"
            >
                {{ prop }}
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { loadIcon } from '@iconify/vue';

export default defineNuxtComponent({
    name: 'ProjectsFilterComponent',
    props: {
        projects: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            filterProps: [
                'Narrative Film',
                'Documentary/Hybrid',
                'Commercial',
                'Musicvideo',
                'Web Development',
            ],
            activeFilters: [],
            filterHidden: true,
        };
    },
    watch: {
        // Wait on projects to load to update the filter
        projects() {
            this.$emit('updateFilter', this.activeFilters);
        },
    },
    computed: {
        filterIcon() {
            return this.filterHidden === true
                ? 'heroicons:funnel'
                : 'heroicons:funnel-solid';
        },
    },
    mounted() {
        // Preload filter--open icon
        loadIcon('heroicons:funnel-solid');

        const filterQuery = this.$route.query.filter;
        if (filterQuery) {
            const queryFilters: string[] = [];
            filterQuery
                .toString()
                .split(',')
                .forEach((filter: string) => queryFilters.push(filter));

            for (let i = 0; queryFilters.length >= i; i++) {
                if (this.filterProps.includes(queryFilters[i]))
                    this.activeFilters.push(queryFilters[i] as never);
                else if (queryFilters[i] !== undefined) {
                    this.filterProps.forEach((p: string) =>
                        this.activeFilters.push(p as never),
                    );
                }
            }
        } else {
            this.filterProps.forEach((p: string) =>
                this.activeFilters.push(p as never),
            );
        }

        this.$emit('updateFilter', this.activeFilters);

        if (window.innerWidth >= 640) this.filterHidden = false;
    },
    methods: {
        toggleFilter(prop: never) {
            // Disable Filter
            if (this.activeFilters.includes(prop)) {
                const activeFiltersIndex = this.activeFilters.indexOf(prop);
                this.activeFilters.splice(activeFiltersIndex, 1);
                this.$emit('updateFilter', this.activeFilters);
                return;
            }

            // Enable Filter
            this.activeFilters.push(prop);

            this.$emit('updateFilter', this.activeFilters);
        },
        toggleFilterHide() {
            if (window.innerWidth <= 640)
                this.filterHidden = !this.filterHidden;
        },
    },
});
</script>
